import {
  documentTypeField,
  documentNumberField,
  emailField,
  clientNumberField,
  captchaField
} from 'constants/fields';
import { appConfig, DOCUMENT } from 'config/customization';

export const PUBLIC_IDENTITY_FIELDS =
  appConfig.signInMethod === DOCUMENT
    ? [documentTypeField, documentNumberField, clientNumberField, captchaField]
    : [emailField, clientNumberField, captchaField];
